class WhypWorkIndex extends HTMLElement {
  connectedCallback() {
    this.buttons = [...this.querySelectorAll('[data-work-filter]')];
    this.cards = [...this.querySelectorAll('[data-work-card]')];
    this.result = this.querySelector('[data-work-result]');

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.filter(button.dataset.workFilter));
    });
  }

  filter(category) {
    let visible = 0;

    this.buttons.forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.workFilter === category));
    });

    this.cards.forEach((card) => {
      const show = category === 'all' || card.dataset.category === category;
      card.hidden = !show;
      if (show) visible += 1;
    });

    if (this.result) {
      const label = this.buttons.find((button) => button.dataset.workFilter === category)?.textContent.trim();
      this.result.textContent = category === 'all'
        ? `Showing all ${visible} works`
        : `${visible} ${label.toLowerCase()} ${visible === 1 ? 'work' : 'works'}`;
    }
  }
}

if (!customElements.get('whyp-work-index')) {
  customElements.define('whyp-work-index', WhypWorkIndex);
}
